



















































































import { Component, Prop, Vue } from 'vue-property-decorator';
import type { Company } from '@/models/company';

@Component({
    name: 'DeleteCompanyConfirmModal',
    components: {},
})
export default class DeleteCompanyConfirmModal extends Vue {
    @Prop() private company: Company;
    @Prop() private isRemoving: boolean;
    @Prop() private errorMessage: string;

    private confirmedCompanyName: string = '';
    private password: string = '';

    private confirm() {
        this.$emit('confirm', this.confirmedCompanyName, this.password);
    }

    private toggleModal() {
        this.$emit('toggleConfirmModal');
    }

    get isConfirmed() {
        return this.password.length > 0 && this.confirmedCompanyName.toLowerCase() === this.company.name.toLowerCase();
    }
}
